"use client"

import {useLocale} from "next-intl";
import dynamic from "next/dynamic";
import {selectLocaleFromEnOrEs} from "@/lib/utils";
import {useParams} from "next/navigation";
import {DOCS_NAV} from "@/lib/utils/contants/docsNav";

export default function KycPolicyPage() {
    const locale = useLocale();
    const params = useParams();

    const safeLocale = selectLocaleFromEnOrEs(locale);
    const safeDocType = (DOCS_NAV.find(i => i.href === `/docs/${params.docType as string}`) || DOCS_NAV[0]).href.replace("/docs/", "");

    const Doc = dynamic(async () => import(`@/app/components/docs/${safeLocale}/${safeDocType}.md`));


    return (
        <div className={'text-light-gray'}>
            <Doc/>
        </div>
    )
}
